import { Button, colors } from '@insurancemenu/imenu-components-lib';
import { boxShadows } from '@insurancemenu/imenu-components-lib/dist/utils';
import { breakpointsMQ4 } from '@insurancemenu/imenu-components-lib/dist/utils/breakpoints';
import styled from 'styled-components';

export const SectionContentWrapperStyled = styled.div`
  position: relative;
  background-color: ${colors.neutral.white};
  border-radius: 1rem;
  box-shadow: ${boxShadows.light[4]};
  height: 50rem;
  box-sizing: border-box;
  overflow-y: auto;

  ${breakpointsMQ4.md.down} {
    height: auto;
  }
`;

export const ButtonsWrapperStyled = styled.div`
  margin: 8rem auto 5rem;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 2rem;
`;

export const ButtonStyled = styled(Button)`
  ${breakpointsMQ4.sm.down} {
    width: 100%;
    min-width: unset;
  }
`;

export const BackButtonStyled = styled(ButtonStyled)`
  background-color: ${colors.neutral.white};

  &:hover {
    background-color: ${colors.blue[600]};
  }
`;
